export default __webpack_public_path__ + "static/shs-6a75a323c277180dd796cb96d8e94706.jpg";